/**
 * The published legal pages (`KLQ-20260814-007`).
 *
 * **Short on purpose.** The documents themselves are not translated here — they are files in
 * the backend repository, reviewed by counsel, served whole. What this catalogue carries is
 * the chrome around them: the wordmark, the three states, and the line naming the version.
 * A legal text inside a message catalogue would be a fifth copy of something that has to
 * have exactly one.
 */
export const legalEn = {
  wordmark: 'KALQA',
  loading: 'Loading…',
  failed: 'That document could not be loaded. Try again.',
  'notPublished.title': 'Not published yet',
  'notPublished.body':
    'This document is being prepared and has not been published. Nothing here is in force until it is.',
  'meta.version': 'Version {version}, in force since {date}',
  'meta.originalLanguage': 'Shown in the language of the original ({locale}).',
  'nav.label': 'Legal documents',
  'nav.imprint': 'Imprint',
  'nav.terms': 'Terms of service',
  'nav.privacy': 'Privacy policy',
  'nav.avv': 'Order processing agreement',
  'nav.subprocessors': 'Subprocessors',
  'download.pdf': 'Download PDF',
} as const;

export type LegalMessageKey = keyof typeof legalEn;
